import React from 'react';
import { Mathclasses9to122026 } from '../views';

const MathClubPage = () => {
  return <Mathclasses9to122026/>;
};

export default MathClubPage;